export const initialState = {
  donorAgreement: {
    userAgree: false,
    termsAgree: false
  },
  authorizationForDisclosureAgreement: {
    userAgree: false,
    termsAgree: false
  },
  assignmentOfBenefitAgreement: {
    userAgree: false,
    termsAgree: false
  }
};
